"use client";

import { useAtomValue } from "jotai";
import { useSyncExternalStore } from "react";
import type { StudentsResult } from "@repo/actions/filterRelationsToStudents";
import { parentStudentsAtom } from "./parentStudents";
const EMPTY_STUDENTS: StudentsResult = [];
function subscribeNoop() {
  return () => {};
}

/**
 * Parent students hydrated outside `"use cache"` (header / course route).
 * The server snapshot is always empty so cached RSC never serializes a roster.
 */
export function useParentStudents() {
  const students = useAtomValue(parentStudentsAtom);
  const isClient = useSyncExternalStore(subscribeNoop, _temp, _temp2);
  return isClient ? students : EMPTY_STUDENTS;
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}